/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon20Regular = forwardRef('DevCodeIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.968 2.716a.75.75 0 1 0-1.436-.432l-4.5 15a.75.75 0 1 0 1.436.431l4.5-15Z" }),
        React.createElement("path", { d: "M5.205 5.095a.75.75 0 0 1 0 1.06L1.891 9.47a.75.75 0 0 0 0 1.06l3.314 3.315a.75.75 0 1 1-1.06 1.06L.83 11.591a2.25 2.25 0 0 1 0-3.182l3.315-3.314a.75.75 0 0 1 1.06 0Z" }),
        React.createElement("path", { d: "M14.79 5.095a.75.75 0 0 1 1.06 0l3.315 3.314a2.25 2.25 0 0 1 0 3.182l-3.315 3.314a.75.75 0 1 1-1.06-1.06l3.314-3.315a.75.75 0 0 0 0-1.06L14.79 6.155a.75.75 0 0 1 0-1.06Z" })));
});
